import { IconButton, Tooltip } from '@material-ui/core';

import { useApplicationButtonIconStyles } from '@/components/modules/Application/hooks/useApplicationButtonIconStyles';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

export const DeleteButton = ({ handleClick }: { handleClick: () => void }) => {
  const { size, color, buttonStyles } = useApplicationButtonIconStyles();

  return (
    <Tooltip title={<Text tId={'DELETE_ITEM'} />}>
      <IconButton size="small" onClick={handleClick} style={buttonStyles}>
        <Icon size={size} color={color}>
          delete
        </Icon>
      </IconButton>
    </Tooltip>
  );
};
